import { render, staticRenderFns } from "./dPassword.vue?vue&type=template&id=55901aaa&"
import script from "./dPassword.vue?vue&type=script&lang=js&"
export * from "./dPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports